import { Button, Container, Label, SliderInput } from '@playcanvas/pcui';
import { Events } from '../events';
import { localize } from './localization';
import { Tooltips } from './tooltips';

class MovementControls extends Container {
    constructor(events: Events, tooltips: Tooltips, args = {}) {
        args = {
            ...args,
            id: 'movement-controls'
        };

        super(args);

        this.dom.addEventListener('pointerdown', (event) => {
            event.stopPropagation();
        });

        // Speed control section
        const speedLabel = new Label({
            text: localize('options.camera-fly-speed'),
            class: 'speed-control-label'
        });

        const speedSlider = new SliderInput({
            class: 'speed-control-slider',
            min: 0.1,
            max: 60,
            precision: 1,
            value: 5,
        });

        this.append(speedLabel);
        this.append(speedSlider);

        // Handle camera speed events
        events.on('camera.flySpeed', (value: number) => {
            speedSlider.value = value;
        });

        speedSlider.on('change', (value: number) => {
            events.fire('camera.setFlySpeed', value);
        });

        tooltips.register(speedSlider, localize('options.camera-fly-speed'), 'left');

        // Create buttons for the 3x2 grid with directional symbols
        const buttonQ = new Button({ class: 'movement-btn', text: '↓' }); // Down
        const buttonW = new Button({ class: 'movement-btn', text: '▲' }); // Forward
        const buttonE = new Button({ class: 'movement-btn', text: '↑' }); // Up
        const buttonA = new Button({ class: 'movement-btn', text: '◀' }); // Left
        const buttonS = new Button({ class: 'movement-btn', text: '▼' }); // Backward
        const buttonD = new Button({ class: 'movement-btn', text: '▶' }); // Right

        // Create rows
        const topRow = new Container({ class: 'movement-row' });
        const bottomRow = new Container({ class: 'movement-row' });

        topRow.append(buttonQ);
        topRow.append(buttonW);
        topRow.append(buttonE);

        bottomRow.append(buttonA);
        bottomRow.append(buttonS);
        bottomRow.append(buttonD);

        this.append(topRow);
        this.append(bottomRow);

        // Register tooltips
        tooltips.register(buttonQ, 'Move Down (Q)', 'top');
        tooltips.register(buttonW, 'Move Forward (W)', 'top');
        tooltips.register(buttonE, 'Move Up (E)', 'top');
        tooltips.register(buttonA, 'Move Left (A)', 'top');
        tooltips.register(buttonS, 'Move Backward (S)', 'top');
        tooltips.register(buttonD, 'Move Right (D)', 'top');

        // Simulate keyboard events when buttons are clicked
        const simulateKeyPress = (key: string) => {
            const keydownEvent = new KeyboardEvent('keydown', {
                key: key,
                code: `Key${key.toUpperCase()}`,
                bubbles: true,
                cancelable: true
            });

            document.body.dispatchEvent(keydownEvent);

            // Quick release after 100ms
            setTimeout(() => {
                const keyupEvent = new KeyboardEvent('keyup', {
                    key: key,
                    code: `Key${key.toUpperCase()}`,
                    bubbles: true,
                    cancelable: true
                });
                document.body.dispatchEvent(keyupEvent);
            }, 100);
        };

        // Add click handlers
        buttonQ.on('click', () => simulateKeyPress('q'));
        buttonW.on('click', () => simulateKeyPress('w'));
        buttonE.on('click', () => simulateKeyPress('e'));
        buttonA.on('click', () => simulateKeyPress('a'));
        buttonS.on('click', () => simulateKeyPress('s'));
        buttonD.on('click', () => simulateKeyPress('d'));
    }
}

export { MovementControls };
